// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"9cf3b19c","513":"67352f66","703":"44578442"}[chunkId] + ".chunk.js";
};